import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ServiceClientMappingRoute,
  ServiceClientMappingPathName,
} from '@/modules/ta/serviceclientmapping/serviceclientmapping.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ServiceClientMappingRoute.SERVICECLIENTMAPPINGS}`,
      name: ServiceClientMappingPathName.SERVICECLIENTMAPPINGS,
      component: () =>
        import(
          /* webpackChunkName: "serviceclientmappings-page" */ './pages/ServiceClientMappingsPage.vue'
        ),
    },
    {
      path: `/${ServiceClientMappingRoute.SERVICECLIENTMAPPINGS}/new`,
      name: ServiceClientMappingPathName.SERVICECLIENTMAPPINGFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "serviceclientmapping-form-page" */ './pages/ServiceClientMappingFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ServiceClientMappingRoute.SERVICECLIENTMAPPINGS}/:id`,
      name: ServiceClientMappingPathName.SERVICECLIENTMAPPINGFORM,
      component: () =>
        import(
          /* webpackChunkName: "serviceclientmapping-form-page" */ './pages/ServiceClientMappingFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.SERVICECLIENTMAPPING
);
